import { useState } from 'react';
import posthog from 'posthog-js';
import useMountEffect from './useMountEffect';

const readFlag = (flag: string): boolean => !!posthog.isFeatureEnabled(flag);

/**
 * A PostHog flag read into state and kept current. The app renders before `posthog.identify`, so
 * a flag read during render can be the anonymous answer; subscribing re-renders the caller when
 * the user's real flags land.
 */
const useSubscribedFlag = (flag: string): boolean => {
	const [enabled, setEnabled] = useState(() => readFlag(flag));

	useMountEffect(() => {
		setEnabled(readFlag(flag));
		return posthog.onFeatureFlags(() => setEnabled(readFlag(flag)));
	});

	return enabled;
};

export default useSubscribedFlag;
